module.exports = __webpack_public_path__ + "img/health11_7-9-2021.9d02eb53.jpg";